import config from '../config/config';

const loadGoogleCaptchaTag = () => {
	const scriptElement = document.createElement('script');
	scriptElement.src = `https://www.google.com/recaptcha/api.js?render=${config.googleCaptchaClientKey}`;
	document.head.appendChild(scriptElement);
}

const Bootstrap = () => {
	loadGoogleCaptchaTag()
}


Bootstrap();